class RecurringInvoice {
    getAsync() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    data: {
                        current_page: 1,
                        data: [
                            {
                                id: 1,
                                customer_id: 51,
                                frequency: 9,
                                title: 'coronas',
                                total: 7000,
                                discount: 0,
                                grandtotal: 14000,
                                note: '',
                                start_date: '2-5-2020',
                                end_date: '2-6-2020',
                                created_at: '2-4-2020',
                                updated_at: ''
                            },
                            {
                                id: 2,
                                customer_id: 52,
                                frequency: 12,
                                title: 'coronas2',
                                total: 5000,
                                discount: 5,
                                grandtotal: 11000,
                                note: '',
                                start_date: '2-6-2020',
                                end_date: '2-29-2020',
                                created_at: '2-4-2020',
                                updated_at: ''
                            },
                            {
                                id: 3,
                                customer_id: 53,
                                frequency: 19,
                                title: 'coronas3',
                                total: 8000,
                                discount: 10,
                                grandtotal: 21000,
                                note: '',
                                start_date: '2-5-2020',
                                end_date: '',
                                created_at: '2-4-2020',
                                updated_at: ''
                            }
                        ],
                        first_page_url: "http://wawan.amy/api/invoices?page=1",
                        from: 1,
                        last_page: 1,
                        last_page_url: "http://wawan.amy/api/invoices?page=1",
                        next_page_url: null,
                        path: "http://wawan.amy/api/invoices",
                        per_page: 15,
                        prev_page_url: null,
                        to: 1,
                        total: 1,
                    }
                })
            }, 500)
        })
    }

    showAsync() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    data: {
                        id: 1,
                        customer_id: 51,
                        frequency: 9,
                        title: 'coronas',
                        total: 7000,
                        discount: 0,
                        grandtotal: 14000,
                        note: '',
                        start_date: '2-5-2020',
                        end_date: '2-29-2020',
                        created_at: '2-4-2020',
                        updated_at: '',
                        payment_terms: "[{"+"\"description\""+":"+"\"cash\""+","+"\"percentage\""+":"+"\"0100\""+"}]",
                        terms: '',
                        token: "$2y$10$6QVnV9gPgl29a.ACWN7cauanstQFizF/9Gf9yaGSmrXFEl5zcK14i",
                        customer: {
                            id: 52,
                            user_id: 3,
                            name: "mr. B",
                            email: "mrb@gmail.com",
                            phone: "777",
                            address: null,
                            city: null,
                            province: null,
                            country: null,
                            created_at: "2020-02-04 12:00:50",
                            updated_at: "2020-02-04 12:00:50",
                            company: {
                                id: 51,
                                owner_id: 52,
                                owner_type: "App\Models\Customer",
                                name: "AndroMeda",
                                description: "company dummy",
                                address: "jl. Jalan Bro no.-17",
                                logo: null,
                                website: "",
                                phone_no: "",
                                email: "",
                                created_at: "2020-02-04 12:00:50",
                                updated_at: "2020-02-04 12:00:50",
                                logo_url: null
                            }
                        },
                        details: [
                            {
                                id: 3,
                                invoice_id: 2,
                                name: "abcde",
                                description: null,
                                price: 200000,
                                qty: 3,
                                subtotal: 600000,
                                created_at: "2020-02-04 17:49:06",
                                updated_at: "2020-02-04 17:49:06"
                            },
                            {
                                id: 4,
                                invoice_id: 2,
                                name: "efgh",
                                description: null,
                                price: 47500,
                                qty: 4,
                                subtotal: 190000,
                                created_at: "2020-02-04 17:49:07",
                                updated_at: "2020-02-04 17:49:07"
                            }
                        ]
                    },
                })
            }, 500)
        })
    }
}

export default new RecurringInvoice